export const formatDate = (
  dateString: string,
  formatType: '2-digit' | 'delivery' | 'delivery-long' | 'numeric' = 'numeric',
  timeZone: 'UTC' | undefined = undefined,
) => {
  const date = new Date(dateString);
  if (formatType === 'delivery') {
    const day = date.toLocaleString('en-US', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      timeZone,
    });
    const hour = date.toLocaleString('en-US', {
      hour12: true,
      hour: '2-digit',
      minute: '2-digit',
      timeZone,
    });
    return `${day} at ${hour}`;
  }
  if (formatType === 'delivery-long') {
    const day = date.toLocaleString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      timeZone,
    });
    const hour = date.toLocaleString('en-US', {
      hour12: true,
      hour: '2-digit',
      minute: '2-digit',
      timeZone,
    });
    return `${day} at ${hour}`;
  }
  return date.toLocaleString('en-US', {
    year: formatType,
    month: '2-digit',
    day: '2-digit',
    timeZone,
  });
};

export const formatDolar = (value: number) =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(value);
